import classnames from 'classnames'

import { Tag } from './index'

interface Props {
  className?: string
}

export function CenteredAlert({ children, className }: React.PropsWithChildren<Props>) {
  return (
    <div className={classnames('flex min-h-120 w-full items-center justify-center', className)}>
      <Tag size="large" variant="bordered">
        {children}
      </Tag>
    </div>
  )
}
